import { render, staticRenderFns } from "./ModalDetailsDispatch.vue?vue&type=template&id=70e58745"
import script from "./ModalDetailsDispatch.vue?vue&type=script&lang=js"
export * from "./ModalDetailsDispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports